/**
 * a list of phoneme segments by language from https://phoible.org/,
 * when there were multiple sets of segments for the same language from different sources,
 *  tacked on uniquifying numbers
 * did a few fixes on the raw data:  N>ɴ  R>ʀ  R̪>ʀ̪  R̪|R>ʀ̪|ʀ  R̪̥|R̥>ʀ̪̥|ʀ̥  R̪̰|R̰>ʀ̪̰|ʀ̰
 *  removed "
 */
export let segmentsByLanguage: Record<string, string> = {};
export let isSegmentsByLanguageLoaded = false;

/** set the language-to-phoneme-segments collection */
export function setSegmentsByLanguage(data: Record<string, string>) {
  segmentsByLanguage = data;
  isSegmentsByLanguageLoaded = true;
}
